import { Fragment, useContext, useState } from "react";

import classes from './PassKey.module.scss';
import LoginContext from '../../../store/login-context';
import SubmitBtn from '../../Form/submit-button/submit-button.component';
import arrowRightBlue from '../../../assets/icons/arrow-right-blue.svg';
import arrowLeftBlue from '../../../assets/icons/arrow-left-blue.svg';
import bird from '../../../assets/img/bird_right_hand_center.png';
import passkeyImg from '../../../assets/img/passkey.svg';
import Ajax from '../../../Handler/Ajax';
import * as asyncAjax from '../../../Handler/Ajax';
import Toast from '../../Form//Toast';
import Modal from '../../General/Static/Modal/Modal';
import PassKeyJoinPopup from "./PassKeyJoinPopup/PassKeyJoinPopup";
import Backdrop from '../../General/Static/BackDrop/Backdrop';
import PassKeyExpiredPopup from "./PassKeyExpiredPopup/PassKeyExpiredPopup";
import birdPhoneSmile from '../../../assets/img/mobileBirdSmile.png';


declare function Translate(key: string): string;
declare var _curLang: any;
declare var _loginMethodSmsOtpUrl: any;
declare var _loginTypeWebAuthn: any;

const PassKey = () => {

    const ctx = useContext(LoginContext);

    const [serverMessage,setServerMessage] = useState(Translate(''));
    const [showModal,setShowModal] = useState(false);
    const [showExpiredModal,setShowExpiredModal] = useState(false);
    const [isBackDrop, setIsBackDrop] = useState(false);

    const onChangeLoginHandler = () => {
      localStorage.removeItem("preferredLoginType"); 
      sessionStorage.removeItem('showPkBtn');
      window.location = _loginMethodSmsOtpUrl;
    }
    
    const onChangeLoginPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            onChangeLoginHandler();
        }
    };

    const doPkAuth = () => {
      setServerMessage('');

      if (!window.PublicKeyCredential){
        setServerMessage(Translate('N_General_Error_Passkey_Not_Supported'));          
      }
      else{
        if(!ctx.devMode){
          setIsBackDrop(true);
          asyncAjax.doAuth()
            .then((pkCredential: any) => {
                //create custom event id for glassbox
                const userId = atob(pkCredential.response.userHandle);
                if(userId.length === 9){         
                    const gbDetector = window['_detector']; 
                    if(gbDetector){
                        gbDetector.triggerCustomEvent('userIsraeliIdLogin', userId);
                    }
                }

                Ajax.sendAuthPk(pkCredential)
                    .then(()=>{
                    setIsBackDrop(false);
                    localStorage.setItem('preferredLoginType', _loginTypeWebAuthn );
                    ctx.setSuccess();
                    })
                    .catch((error) => {
                    setIsBackDrop(false);
                    if(error === "N_General_Error_AUTHENTICATOR_EXPIRED"){
                        setShowExpiredModal(true);
                    }
                    else{
                        setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
                    }                  
                    })          
            })
            .catch((error) => {
              setIsBackDrop(false);
              if(error !== 'cancel'){
                setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                     
              }
            });
        }
        else{
          setIsBackDrop(true);
          asyncAjax.doAuthDemo()
          .then((pkCredential: any) => { 
            setIsBackDrop(false);
            localStorage.setItem('preferredLoginType', _loginTypeWebAuthn );                                  
            ctx.setSuccess();       
          })
          .catch((error) => {
            setIsBackDrop(false);
            if(error !== 'cancel'){
              setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR')); 
            }                    
          });
        }
      }
    };

    const toLoginHandler = () => {        
        sessionStorage.setItem('showPkBtn','false');
        localStorage.removeItem("preferredLoginType"); 
        window.location = _loginMethodSmsOtpUrl;
    };

    const joinBtnHandler = () => {
        setShowModal(true);
    };

    const closePopup = () => {
        setShowModal(false);
        document.getElementById('pkJoinBtn')?.focus();
    };

    const backToBasicLogin = () => {
        localStorage.removeItem("preferredLoginType"); 
        window.location = _loginMethodSmsOtpUrl;
    };

    const closeExpiredPopup = () => {
        setShowExpiredModal(false);
    };

    return (
        <Fragment>
            {isBackDrop &&
              <Backdrop />
            }

            {showModal &&
                <Modal >                    
                    <PassKeyJoinPopup close={closePopup} Continue={toLoginHandler}/>
                </Modal>
            }

            {showExpiredModal &&
                <Modal>
                    <PassKeyExpiredPopup back={backToBasicLogin} Continue={toLoginHandler} close={closeExpiredPopup} />
                </Modal>
            }

            {/* <div className={classes.up_note}>
                <h1 className={classes.title}>{Translate('N_Login_info_1')}</h1>
            </div> */}
            <form className={`normal-form ${classes.pk_container}`}>
                <div className={classes.pk_other_login}>
                    <>
                        <img  src={(_curLang === 'en' || _curLang === 'ru' ? arrowLeftBlue : arrowRightBlue)}  id='goBackImg' aria-hidden="true" className='goBackImg' onClick={onChangeLoginHandler}/>
                        <span aria-hidden="true">&nbsp;&nbsp;</span>                        
                        <a id='goBackLink' 
                            className='goBackLink' 
                            onClick={onChangeLoginHandler} 
                            onKeyPress={onChangeLoginPress}
                            tabIndex={0}>
                            {Translate('N_Login_application_pop_up_3')}
                        </a>
                    </>  
                </div>
                <div className={classes.pk_heading_container}>
                    <div className={classes.pk_login_heading}>
                        <img
                            className=''
                            src={passkeyImg} 
                            aria-hidden="true"                               
                        />
                        <div className={classes.pk_title_desc} role="heading" aria-level={2}>
                            <div className={classes.pk_title}>                            
                                <span>{Translate('N_Login_Quick_Entry')}</span>
                            </div>                            
                        </div>
                    </div>
                    <div className={classes.pk_sub_title}>
                        <span className={classes.pk_sub_title_text}>{Translate('N_Login_Quick_Entry_Desc')}</span>
                        <span className={classes.pk_sub_title_text_mobile}>{Translate('N_Login_Quick_Entry_Desc_Mobile')}</span>                                            
                    </div>
                </div>
                {serverMessage.length > 0 && (
                  <div className='mt-2'>
                    <Toast message={serverMessage} />
                  </div>
                )}
                <div className={classes.pk_button_container}>
                    <div className={classes.pk_button_wrapper}>
                        <SubmitBtn
                            title={Translate('N_Login_password_login_button')}
                            id="pkSubmit"
                            action={doPkAuth}
                            showIcon={true}
                            disabled={false}
                        />
                    </div>
                </div>
                <div className={classes.pk_join_button_container}>
                    <button type="button" id="pkJoinBtn" className={classes.pk_join_button} onClick={joinBtnHandler}>
                        {Translate('N_Login_Quick_Entry_Join')}
                    </button>
                </div>
                <div className={classes.pk_hr_wrraper}>
                    <div className={classes.pk_hr}></div>
                </div>
                
                <div className={classes.pk_login_types_mobile} id="changeLoginMobile" onClick={onChangeLoginHandler} >
                    <span>{Translate('N_General_Other_Login_Type')}</span>
                </div>

                <div className={classes.pk_desc_wrapper}>             
                    <div className={classes.pk_desc_container}>
                        <div className={classes.pk_desc_icon_container}>
                            <div className={classes.pk_desc_icon}>
                                    <span className={classes.pk_desc_icon_text}>i</span>
                            </div> 
                        </div>
                        <div>                        
                            <div className={classes.pk_desc_title}>                            
                                {Translate('N_General_Account_Protect_Title')}
                            </div>                       
                            <div className={classes.pk_desc_text}>
                                <span className={classes.bullet}>&#x2022;</span>
                                <span>{Translate('N_Passkey_Prerequisites_1')}</span>
                            </div>
                            <div className={classes.pk_desc_text}>
                                <span className={classes.bullet}>&#x2022;</span>
                                <span>{Translate('N_Passkey_Prerequisites_2')}</span>
                            </div>
                        </div>
                    </div> 
                </div>

                <div className={classes.bird} aria-hidden="true">
                    <img src={bird} alt="" />
                </div>

                <div className={classes.passkey_login_img}>
                    <img src={birdPhoneSmile}  alt="bird"/>
                </div>    
                               
            </form>
        </Fragment>
    )
};
export default PassKey;